export const selectReceivedMessages = (state: any) => state.receivedMessage;
export const selectunReadMessages = (state: any) => state.unReadMessage;
export const selectDisplayMessage = (state: any) => state.displayMessage;
export const selectNotificationNumber = (state: any) => state.notificationNumber;
export const selectPushNotification = (state: any) => state.pushNotification;
export const selectMessageCrud = (state: any) => state.messageId;
export const selectTotalItemsMessages = (state: any) => state.totalItems;

